import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'

export default function AuthPage() {
  const { signIn, signUp } = useAuth()
  const [isLogin, setIsLogin] = useState(true)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [fullName, setFullName] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setError(''); setSuccess(''); setLoading(true)
    if (isLogin) {
      const { error } = await signIn(email, password)
      if (error) setError(error.message)
    } else {
      const { error } = await signUp(email, password, fullName)
      if (error) setError(error.message)
      else setSuccess('Ελέγξε το email σου για επιβεβαίωση!')
    }
    setLoading(false)
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <span style={styles.logoIcon}>♻️</span>
          <h1 style={styles.logoText}>WasteReward</h1>
          <p style={styles.logoSub}>Ανακύκλωσε. Κέρδισε. Επιβραβεύσου.</p>
        </div>

        <div style={styles.tabs}>
          <button style={{...styles.tab, ...(isLogin ? styles.tabActive : {})}} onClick={() => setIsLogin(true)}>Σύνδεση</button>
          <button style={{...styles.tab, ...(!isLogin ? styles.tabActive : {})}} onClick={() => setIsLogin(false)}>Εγγραφή</button>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          {!isLogin && (
            <div style={styles.field}>
              <label style={styles.label}>Ονοματεπώνυμο</label>
              <input style={styles.input} type="text" value={fullName} onChange={e => setFullName(e.target.value)} placeholder="Μαρία Παπαδοπούλου" required />
            </div>
          )}
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input style={styles.input} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="email@example.com" required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Κωδικός</label>
            <input style={styles.input} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required minLength={6} />
          </div>

          {error && <div style={styles.error}>{error}</div>}
          {success && <div style={styles.success}>{success}</div>}

          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Παρακαλώ περίμενε...' : (isLogin ? 'Σύνδεση' : 'Δημιουργία λογαριασμού')}
          </button>
        </form>
      </div>
    </div>
  )
}

const styles = {
  container: { minHeight: '100vh', background: '#f0faf4', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' },
  card: { background: 'white', borderRadius: 16, padding: '2rem', width: '100%', maxWidth: 400, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' },
  logo: { textAlign: 'center', marginBottom: '1.5rem' },
  logoIcon: { fontSize: 48, display: 'block', marginBottom: 8 },
  logoText: { margin: 0, color: '#1A6B3C', fontSize: 28, fontWeight: 700 },
  logoSub: { color: '#666', fontSize: 14, margin: '4px 0 0' },
  tabs: { display: 'flex', background: '#f5f5f5', borderRadius: 8, padding: 4, marginBottom: '1.5rem' },
  tab: { flex: 1, padding: '8px', border: 'none', background: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, color: '#666', fontWeight: 500 },
  tabActive: { background: 'white', color: '#1A6B3C', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' },
  form: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 14, fontWeight: 500, color: '#333' },
  input: { padding: '10px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 15, outline: 'none' },
  btn: { padding: '12px', background: '#1A6B3C', color: 'white', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer', marginTop: 4 },
  error: { background: '#fef2f2', color: '#dc2626', padding: '10px 12px', borderRadius: 8, fontSize: 14 },
  success: { background: '#f0fdf4', color: '#16a34a', padding: '10px 12px', borderRadius: 8, fontSize: 14 },
}
